import React from 'react';
import Divider from '@/components/divider/Divider';
import ShowHide from '@/components/showHide';
import Main from '@/core/views/main/main';
import useFilesCategories from '@/modules/files/hooks/useFilesCategories/useFilesCategories';
import { useHistoryLocation, useHistoryQuery } from '@/navigation';
import Navigator from '@/modules/files/components/navigator/navigator';

const Home: React.FC = () => {
  const { idCategory } = useHistoryQuery();
  const { pathname } = useHistoryLocation();

  const { breadcrumbCategories } = useFilesCategories({
    selectedCategory: idCategory || null,
    isUploadPage: idCategory && pathname.includes('upload'),
  });

  return (
    <Main>
      <ShowHide transition='slideToDown' visible={!!idCategory}>
        <Divider space={1} />
      </ShowHide>

      <ShowHide transition='slideToDown' visible={!!idCategory}>
        <Navigator navigation={breadcrumbCategories} />
      </ShowHide>
    </Main>
  );
};

export default Home;
